/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { unitTasksService } from '../../../_services/unitTasks.service'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import ConfirmDialog from '../../Shared/ConfirmDialog'
import { FaAngleLeft } from 'react-icons/fa'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import Step5 from './Step5'
import Step6 from './Step6'

import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

class Form extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      confirmDialogShow: false,
      loading: false,
      key: 'info',
      isModal: this.props.isModal,
      id: this.props.isModal ? this.props.id : this.props.match.params.id,
      taskType: this.props.isModal ? this.props.taskType : this.props.match.params.taskType,
      data: {
        unitId: '',
        taskId: '',
        description: '',
        items: [
          { categoryId: '', brandId: '', productId: '', quantity: 0 }
        ],
        outputs: [
          { categoryId: '', brandId: '', productId: '', quantity: 0 }
        ]
      }
    }


  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {

    const { id } = this.state;

    if (id) {

      this.setState({ loading: true });

      await unitTasksService.getByIdSClum(id)
        .then((res) => {
          console.log(res.data);
          let data = res.data;

          data["lastDescription"] = data.description;
          data["description"] = '';

          let items = []
          let outputs = []

          if (data.items && data.items.length>0) {
            items = data.items.filter(el => parseInt(el.taskOperationProductType, 0) === 0)
            outputs = data.items.filter(el => parseInt(el.taskOperationProductType, 0) === 1)

            items.forEach(item => {
              item["extraQuantity"] = 0;
              item["subExtraQuantity"] = 0;
              // if (item.product.id !== "00000000-0000-0000-0000-000000000000") {
              //   item["quantity"] = undefined;
              //   item["subQuantity"] = undefined;
              // }
            });

            outputs.forEach(item => {
              item["extraQuantity"] = 0;
              item["subExtraQuantity"] = 0;
              item["quantity"] = undefined;
              item["subQuantity"] = undefined;
              item["waste"] = 0;
              item["subWaste"] = 0;
            });

            data["items"] = items;
            data["outputs"] = outputs;

          }


          data["shift"] = '';
          data["shiftManager"] = '';
          data["unitManager"] = '';
          data["qc"] = '';
          data["techniciens"] = [];

          console.log(data);
          this.setState({ data: data, loading: false })

        })
        .catch((error) => {

          // console.log(error);

          this.setState({ loading: false });

        });

    }


  };

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });

    let dto = {};
    // dto["unitId"] = this.state.taskFinished == true ? undefined : values.unitId;
    dto["taskId"] = this.state.data.taskId;
    dto["PreviousUnitTaskId"] = this.state.data.id;
    dto["taskFinished"] = this.state.taskFinished;

    let items = values.items;
    let outputs = values.outputs;

    items.forEach(item => {
      item["taskOperationProductType"] = 0;
      // item["quantity"] = 0;
      // item["subQuantity"] = 0;
    });

    dto["items"] = items.concat(outputs);


    let personnels = [];

    let techniciens = values.techniciens;
    techniciens.forEach(item => {
      personnels.push({ personnelId: item, taskOperationPersonnelType: 0 });
    });

    personnels.push({ personnelId: values.shiftManager, taskOperationPersonnelType: 1 });
    personnels.push({ personnelId: values.unitManager, taskOperationPersonnelType: 2 });
    personnels.push({ personnelId: values.qc, taskOperationPersonnelType: 4 });

    dto["personnels"] = personnels;

    dto["unitId"] = values.unitId;
    dto["shift"] = values.shift;
    dto["description"] = values.description;

    console.log((dto));

    this.setState({ finalDto: dto }, () => {
      this.handleShowConfirmDialog(true)
    })



  }

  handleShowConfirmDialog = (val) => {
    this.setState({ confirmDialogShow: val })
  }

  handleSubmitAfterConfirm = () => {

    this.handleShowConfirmDialog(false)

    if (this.state.taskFinished) {
      this.setState({ taskFinishedLoading: true });
    } else {
      this.setState({ taskSemiFinishedLoading: true });
    }


    taskOperationsService.sclumAddTaskOperation(JSON.stringify(this.state.finalDto))
      .then((res) => {
        console.log(res);

        this.setState({ loading: false, taskFinishedLoading: false, taskSemiFinishedLoading: false });
        toastr.success('ثبت اطلاعات انجام شد');

        this.props.onSubmit()

      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false, taskFinishedLoading: false, taskSemiFinishedLoading: false });
      });

  }

  render() {
    const { data, taskFinishedLoading, taskSemiFinishedLoading } = this.state;
    const itemsCount = data.items.length;
    const outputsCount = data.outputs.length;

    const item = Yup.object().shape({
      quantity: Yup.number().nullable().min(0, 'استفاده شده').required('استفاده شده'),
      waste: Yup.number().nullable().min(0, 'مقدار ضایعات').required('مقدار ضایعات'),
      // productId: Yup.string().trim().nullable().required('محصول')
    });

    const output = Yup.object().shape({
      quantity: Yup.number().nullable().min(0, 'مقدار تولید سالم').required('مقدار تولید سالم'),
      waste: Yup.number().nullable().min(0, 'مقدار ضایعات').required('مقدار ضایعات'),
    });

    const ValidationSchema = Yup.object().shape({
      unitId: Yup.string().trim().nullable().required('واحد'),
      // quantity: Yup.string().trim().nullable().required('مقدار محصول تولید شده'),
      // waste: Yup.string().trim().nullable().required('تعداد ضایعات'),
      items: Yup.array().of(item).min(itemsCount, 'تمامی اطلاعات').required('تمامی اطلاعات محصول'),
      outputs: Yup.array().of(output).min(outputsCount, 'تمامی اطلاعات').required('تمامی اطلاعات محصول'),


      shift: Yup.string().trim().nullable().required('شیفت'),
      shiftManager: Yup.string().trim().nullable().required('سرشیفت'),
      unitManager: Yup.string().trim().nullable().required('مسئول پرس'),
      qc: Yup.string().trim().nullable().required('کنترل کیفی'),
      // techniciens: Yup.array().of(Yup.string()).min(1, 'حداقل 1 اپراتور').required('اپراتورهای پرس'),
    });
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          // setSubmitting(true);
          this.handleSubmit(values);
          setSubmitting(false);
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm,
          } = props;
          return (
            <div>
              <div className="row" style={{ position: "relative" }}>
                <Fab color="secondary" aria-label="refresh" size="small" onClick={() => this.props.onClose()} className="modal-close-btn absolute">
                  <MdClose size="20px" />
                </Fab>
                <form onSubmit={handleSubmit} id="form">

                  {/* <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات فرآیند تولید"> */}
                  <div className="row">
                    <div className="col-lg-10 col-lg-offset-1">
                      <Step1 {...props} taskType={this.state.taskType} />
                      <Step5 {...props} taskType={this.state.taskType} />
                      <Step2 {...props} taskType={this.state.taskType} />
                      <Step4 {...props} taskType={this.state.taskType} />
                      <Step6 {...props} taskType={this.state.taskType} />
                      <Step3 {...props} taskType={this.state.taskType} />
                    </div>
                  </div>

                  <div className="col-lg-10 col-lg-offset-1">
                    <div className="row">
                      <div className="col-md-6 col-xs-6">
                        <button type="submit" className={"btn btn-success btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                          disabled={taskFinishedLoading || taskSemiFinishedLoading}
                          onClick={e => {
                            e.preventDefault();
                            this.setState({ taskFinished: true, dialogTitle: "تایید تکمیل سفارش", dialogText: "آیا این سفارش بصورت کامل تمام شده است؟" }, () => {
                              handleSubmit();
                            })

                          }}
                        >
                          {taskFinishedLoading ?
                            <AiOutlineLoading className="mdi-spin" size="22px" />
                            :
                            'سفارش بصورت کامل انجام شد'
                          }
                        </button>
                      </div>
                      <div className="col-md-6 col-xs-6">
                        <button type="submit" className={"btn btn-info btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                          disabled={taskFinishedLoading || taskSemiFinishedLoading}
                          onClick={e => {
                            e.preventDefault();
                            this.setState({ taskFinished: false, dialogTitle: "تایید عدم اتمام کل سفارش در شیفت جاری", dialogText: "آیا این سفارش در شیفت جاری بصورت کامل تمام نشده و باید در شیفت بعدی ادامه یابد؟" }, () => {
                              // $(this).closest('form').submit()
                              handleSubmit();
                            })
                          }}
                        >
                          {taskSemiFinishedLoading ?
                            <AiOutlineLoading className="mdi-spin" size="22px" />
                            :
                            'سفارش کامل نشده و در شیفت بعدی ادامه خواهد یافت'
                          }
                        </button>
                      </div>
                      <div className="clearfix"></div>
                      <div className="clearfix"></div>
                      <div className="col-md-12">
                        <button className={"btn btn-default btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                          disabled={taskFinishedLoading || taskSemiFinishedLoading}
                          onClick={e => {
                            e.preventDefault();
                            this.props.onClose();
                          }}
                        >
                          بازگشت
                          <FaAngleLeft style={{ verticalAlign: 'middle', marginRight: 5 }} />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* </Tab>
                    <Tab eventKey="materialsTab" title="مواد اولیه"> */}



                  {/* </Tab>

                  </Tabs> */}
                  {/* {JSON.stringify(values)} */}
                </form>
              </div>
              <ConfirmDialog open={this.state.confirmDialogShow}
                onClose={() => this.handleShowConfirmDialog(false)}
                onConfirm={() => this.handleSubmitAfterConfirm()}
                title={this.state.dialogTitle}
                text={this.state.dialogText}
              />
              {this.state.loading ? <Loading /> : ''}
            </div>
          );
        }}
      </Formik>
    );
  }
}

export default Form;
